export var PathPartitionsTimestampGranularity;
(function (PathPartitionsTimestampGranularity) {
    PathPartitionsTimestampGranularity["PATH_PARTITIONS_TIMESTAMP_GRANULARITY_UNSPECIFIED"] = "PATH_PARTITIONS_TIMESTAMP_GRANULARITY_UNSPECIFIED";
    PathPartitionsTimestampGranularity["PATH_PARTITIONS_TIMESTAMP_GRANULARITY_YEAR"] = "YEAR";
    PathPartitionsTimestampGranularity["PATH_PARTITIONS_TIMESTAMP_GRANULARITY_MONTH"] = "MONTH";
    PathPartitionsTimestampGranularity["PATH_PARTITIONS_TIMESTAMP_GRANULARITY_DAY"] = "DAY";
    PathPartitionsTimestampGranularity["PATH_PARTITIONS_TIMESTAMP_GRANULARITY_HOUR"] = "HOUR";
})(PathPartitionsTimestampGranularity || (PathPartitionsTimestampGranularity = {}));
